import React from 'react';
import {
  BulkUploadStepper,
  BulkUploadStepperCircle,
  BulkUploadStepperDivider,
  BulkUploadStepperItem,
  BulkUploadStepperLabel,
} from '../styles';

const getStatus = (stepId, currentStep) => {
  if (stepId < currentStep) return 'complete';
  if (stepId === currentStep) return 'current';
  return 'upcoming';
};

export const BulkUploadWizardStepper = ({ steps, currentStep = 2, onStepClick }) => (
  <BulkUploadStepper>
    {steps.map((step, index) => {
      const status = getStatus(step.id, currentStep);
      const isClickable = status === 'complete' && onStepClick;

      const handleClick = () => {
        if (isClickable) {
          onStepClick(step.id);
        }
      };

      return (
        <React.Fragment key={step.id}>
          <BulkUploadStepperItem
            $clickable={isClickable}
            onClick={handleClick}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
            onKeyDown={isClickable ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick();
              }
            } : undefined}
          >
            <BulkUploadStepperCircle $status={status}>
              {step.id}
            </BulkUploadStepperCircle>
            <BulkUploadStepperLabel $status={status}>{step.label}</BulkUploadStepperLabel>
          </BulkUploadStepperItem>
          {index < steps.length - 1 && <BulkUploadStepperDivider />}
        </React.Fragment>
      );
    })}
  </BulkUploadStepper>
);
